// extracted by mini-css-extract-plugin
export var circle = "_1l-2";
export var icon = "_1l-a";
export var iconHighlight = "_1l-0";
export var lg = "_1l-8";
export var md = "_1l-7";
export var outline = "_1l-4";
export var sm = "_1l-6";
export var square = "_1l-1";
export var xl = "_1l-9";
export var xs = "_1l-5";
export var xxs = "_1l-3";